import { InputWithInsetLabel } from '../../../../DanitComponents/Inputs/InputWithInsetLabel';
import './family-info-tab-center-gutter.css'

const familyInfoInputs = [
    {label: 'Family Name', type: 'familyName'},
    {label: 'Parent/Guardian Name(s)', type: 'primaryParentName'},
    {label: 'Cell Phone', type: 'primaryCellphone'},
    {label: 'Home Phone', type: 'primaryHomePhone'},
    {label: 'Email', type: 'primaryEmail'},
]

const familyAddressInputs = [
    {label: 'Street Address', type: 'addressLine1'},
    {label: 'City', type: 'city'},
    {label: 'State', type: 'state'},
    {label: 'Zip Code', type: 'zipcode'},
]

const FamilyInfoTabCenterGutter = ({family, setFamily}) => {

    const handleFamilyInfoChange = (e, inputType) => {
        setFamily({...family, [inputType]: e.target.value})
    }

    const handleFamilyAddressChange = (e, inputType) => {
        setFamily({...family, address: {...family.address, [inputType]: e.target.value}})
    }

    return (
        <div className="family-info-tab-center-gutter__wrapper">
            <div className='family-info-tab-center-gutter__top-label__wrapper'>
                <div className='family-info-tab-center-gutter__top-label__line'></div>
                <div className='family-info-tab-center-gutter__top-label__words'>FAMILY INFO</div>
                <div className='family-info-tab-center-gutter__top-label__line'></div>
            </div>
            <div className='family-info-tab-center-gutter__input-section'>
                {familyInfoInputs.map((input, index) => 
                    <div className='family-info-tab-center-gutter__input'>
                        <InputWithInsetLabel key={index} label={input.label} changeFunction={(e) => handleFamilyInfoChange(e, input.type)} value={family[input.type]} />
                    </div>
                )}
            </div>
            <div className='family-info-tab-center-gutter__input-section'>
                {familyAddressInputs.map((input, index) => 
                    <div className='family-info-tab-center-gutter__input'>
                        <InputWithInsetLabel key={index} label={input.label} changeFunction={(e) => handleFamilyAddressChange(e, input.type)} value={family['address'][input.type]} />
                    </div>
                )}
            </div>
        </div>
    )
}
export default FamilyInfoTabCenterGutter;